module.exports = __webpack_public_path__ + "assets/img/07a.c069feac.jpg";